var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-card',{attrs:{"titleCard":_vm.$t('sidebar.proposals')}},[_c('proposals-table',{attrs:{"headerProposalTable":_vm.headerProposalTable,"dataProposalTable":_vm.dataProposalTable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }